import { render } from "./SetupSection.vue?vue&type=template&id=7a1de32d"
import script from "./SetupSection.vue?vue&type=script&lang=js"
export * from "./SetupSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__